import React from "react";
import { SOURCE_PROPS } from './source_const.jsx';
import Select from "../../../../common/Select.jsx";
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";

const VectorTypeSetting = ({updateField, sourceField, index}) => {
    const vector = sourceField.vector || {};
    const {minzoom, maxzoom, tiles} = SOURCE_PROPS.vector
    return (
      <>
        <label className='col-xs-12 col-md-12'>
          {tiles.title}
          <MapboxHelpTooltip description={tiles.description} />
          <input
              type="text"
              className="form-control"
              name="tiles"
              data-index={index}
              value={vector.tiles || tiles.default}
              onChange={(e) => updateField(`sourceFields.${index}.vector.tiles`, e.target.value)}
          />
        </label>
        <label className='col-xs-6 col-md-6'>
          {minzoom.title}
          <MapboxHelpTooltip description={minzoom.description} />
          <Select
            value={vector.minzoom || minzoom.default}
            options={Array.from({length : vector.maxzoom || maxzoom.default}, (v,index) => ({value: index, label: index}))}
            onChange={(v) => updateField(`sourceFields.${index}.vector.minzoom`, parseInt(v) || minzoom.default)}
          />
        </label>
        <label className='col-xs-6 col-md-6'>
          {maxzoom.title}
          <MapboxHelpTooltip description={maxzoom.description} />
          <Select
            value={vector.maxzoom || maxzoom.default}
            options={Array.from({length : (maxzoom.default - (vector.minzoom || minzoom.default))}, (v,index) => ({value: maxzoom.max - index, label: maxzoom.max - index})).reverse()}
            onChange={(v) => updateField(`sourceFields.${index}.vector.maxzoom`, parseInt(v) || maxzoom.default)}
          />
        </label>
      </>
    )
}
export default VectorTypeSetting;